export const CONFIG = {
	breakpoint: 1200,
	scrollThreshold: 100
};